import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConsequenceMapElement, ConsequenceMapElementDTO, ConsequenceMapRegion, ConsequenceMapRegionDTO, ConsequenceMapSection, ConsequenceMapSectionDTO } from '../types/consequence-map.interface';

@Injectable({
  providedIn: 'root'
})
export class ConsequenceMapService {
  constructor(private http: HttpClient) { }

  private readonly url = `${environment.API_INSPEC}ConsequenceMap`


  getConsequenceMapRegions(assetId: string): Observable<ConsequenceMapRegionDTO[]> {
    const preventCache = (new Date()).getTime();
    return this.http.get<ConsequenceMapRegionDTO[]>(this.url + `/GetConsequenceMapRegions?assetId=${assetId}&cache_bump=${preventCache}`)
  }

  getConsequenceMapSections(assetId: string): Observable<ConsequenceMapSectionDTO[]> {
    const preventCache = (new Date()).getTime();
    return this.http.get<ConsequenceMapSectionDTO[]>(this.url + `/GetConsequenceMapSections?assetId=${assetId}&cache_bump=${preventCache}`)
  }

  getConsequenceMapElements(assetId: string): Observable<ConsequenceMapElementDTO[]> {
    const preventCache = (new Date()).getTime();
    return this.http.get<ConsequenceMapElementDTO[]>(this.url + `/GetConsequenceMapElements?assetId=${assetId}&cache_bump=${preventCache}`)
  }

  // getConsequenceMapRegion(id: string): Observable<ConsequenceMapRegion> {
  //   return this.http.get<ConsequenceMapRegion>(this.url + `/${id}`);
  // }

  // getConsequenceMapSection(id: string): Observable<ConsequenceMapSection> {
  //   return this.http.get<ConsequenceMapSection>(this.url + `/${id}`);
  // }

  // getConsequenceMapElement(id: string): Observable<ConsequenceMapElement> {
  //   return this.http.get<ConsequenceMapElement>(this.url + `/${id}`);
  // }

  postConsequenceMapRegion(consequenceMapRegion: ConsequenceMapRegionDTO) {
    return this.http.post<{ id: string }>(this.url + "/PostConsequenceMapRegion", consequenceMapRegion);
  }
  
  postConsequenceMapSection(consequenceMapSection: ConsequenceMapSectionDTO) {
    return this.http.post<{ id: string }>(this.url + "/PostConsequenceMapSection", consequenceMapSection);
  }
  
  postConsequenceMapElement(consequenceMapElement: ConsequenceMapElementDTO) {
    return this.http.post<{ id: string }>(this.url + "/PostConsequenceMapElement", consequenceMapElement);
  }

  putConsequenceMapRegion(consequenceMapRegion: ConsequenceMapRegion) {
    return this.http.put(this.url, consequenceMapRegion);
  }
  
  putConsequenceMapSection(consequenceMapSection: ConsequenceMapSection) {
    return this.http.put(this.url, consequenceMapSection);
  }
  
  putConsequenceMapElement(consequenceMapElement: ConsequenceMapElement) {
    return this.http.put(this.url, consequenceMapElement);
  }

  deleteConsequenceMapRegion(id: string) {
    return this.http.delete<boolean>(this.url + `?id=${id}`);
  }

  deleteConsequenceMapSection(id: string) {
    return this.http.delete<boolean>(this.url + `/DeleteConsequenceMapSection?id=${id}`);
  }

  deleteConsequenceMapElement(id: string) {
    return this.http.delete<boolean>(this.url + `/DeleteConsequenceMapElement?id=${id}`);
  }
}
